module.exports = __webpack_public_path__ + "img/sus_users_Melvie.706d6066.png";